export default __webpack_public_path__ + "static/media/intro-loop.85c70e50.mp3";